import * as React from 'react';

import { Breadcrumbs } from '../shared/breadcrumbs';

import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

interface PageHeaderProps {
  title?: string;
  crumbs?: any[];
  hideCrumbs?: boolean;
  noBorder?: boolean;
  children?: React.ReactNode;
}

export const PageHeader: React.FunctionComponent<PageHeaderProps> = ({
  title,
  crumbs,
  noBorder,
  children,
  hideCrumbs,
}) => {
  return (
    <UitkSpacing margin={{ blockstart: 'six', blockend: 'six' }}>
      <header className="container">
        {!hideCrumbs && <Breadcrumbs crumbs={crumbs} />}
        <UitkLayoutFlex
          direction="column"
          className={!noBorder ? 'PageHeader__wrapper PageHeader__wrapper--border' : 'PageHeader__wrapper'}
        >
          <UitkLayoutFlexItem>
            <UitkSpacing margin={{ blockstart: 'three', blockend: 'three' }}>
              <UitkHeading
                tag="h1"
                size={3}
                className={!noBorder ? 'PageHeader__title PageHeader__title--border' : 'PageHeader__title'}
              >
                {title}
              </UitkHeading>
            </UitkSpacing>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem>
            <UitkLayoutFlex direction="column" space="two" className="PageHeader__children">
              {children}
            </UitkLayoutFlex>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </header>
    </UitkSpacing>
  );
};
